import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot, CanActivate } from '@angular/router';
import { AuthStateService } from '../services/auth/auth-state.service';
import { from, Observable, of, switchMap } from 'rxjs';
import { map, take, filter } from 'rxjs/operators';

@Injectable({ providedIn: 'root' })
export class AuthGuard implements CanActivate {
  constructor(
    private readonly router: Router,
    private readonly authState: AuthStateService,
  ) {}

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {
    const rutaSolicitada = this.normalizarRuta(state.url);
    const rutasPublicas = ['/login', '/home', '/not-authorized', '/not-found', '/cotizador'];

    return from(this.authState.rehidratarDesdeIndexedDB()).pipe(
      switchMap(() => {
        if (!this.authState.isLogged) {
          if (!rutasPublicas.includes(rutaSolicitada)) {
            void this.router.navigate(['/'], { queryParams: { return: state.url } });
            return of(false);
          }
          return of(true);
        }

        return this.authState.rutasPermitidas$.pipe(
          filter((rutas) => rutas.length > 0),
          take(1),
          map((rutas) => {
            const esRutaPermitida = rutas.some((r) => {
              if (r === rutaSolicitada) return true;
              return rutaSolicitada.startsWith(r + '/');
            });

            if (esRutaPermitida || rutasPublicas.includes(rutaSolicitada)) {
              return true;
            }
            void this.router.navigate(['/not-found']);
            return false;
          }),
        );
      }),
    );
  }

  private normalizarRuta(url: string): string {
    const rutaSinParams = url.split('?')[0].split('#')[0];
    return rutaSinParams.endsWith('/') && rutaSinParams.length > 1 ? rutaSinParams.slice(0, -1) : rutaSinParams;
  }
}
